import React from 'react';
import PropTypes from "prop-types";
export var I18nShapeProps = () => <div />;
I18nShapeProps.propTypes = {
  mapping: PropTypes.shape({}),
  mappingFunc: PropTypes.func,
  formatNumber: PropTypes.func,
  formatDateTime: PropTypes.func,
  locale: PropTypes.string
};

try {
  // @ts-ignore
  I18nShapeProps.displayName = "I18nShapeProps"; // @ts-ignore

  I18nShapeProps.__docgenInfo = {
    "description": "",
    "displayName": "I18nShapeProps",
    "props": {
      "mapping": {
        "defaultValue": null,
        "description": "",
        "name": "mapping",
        "required": false,
        "type": {
          "name": "{ [key: string]: Renderable<object>; } | undefined"
        }
      },
      "mappingFunc": {
        "defaultValue": null,
        "description": "",
        "name": "mappingFunc",
        "required": false,
        "type": {
          "name": "((value: string) => string) | undefined"
        }
      },
      "formatNumber": {
        "defaultValue": null,
        "description": "",
        "name": "formatNumber",
        "required": false,
        "type": {
          "name": "((x: number) => string) | undefined"
        }
      },
      "formatDateTime": {
        "defaultValue": null,
        "description": "",
        "name": "formatDateTime",
        "required": false,
        "type": {
          "name": "((x: Date) => string) | undefined"
        }
      },
      "locale": {
        "defaultValue": null,
        "description": "",
        "name": "locale",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/views/i18n/props.tsx#I18nShapeProps"] = {
      docgenInfo: I18nShapeProps.__docgenInfo,
      name: "I18nShapeProps",
      path: "src-docs/src/views/i18n/props.tsx#I18nShapeProps"
    };
} catch (__react_docgen_typescript_loader_error) {}